export var SUCCESS_STATUS = {
  OK: 200
};